import { getChatHistory } from '../api';
import { useAccount } from './ui/account-context';

export interface Message {
    type: 'user' | 'bot';
    text: string;
    timestamp: string;
}

export interface ChatSession {
    sessionId: string;
    agentId?: string; // Added agentId
    created: string;
    lastUpdated: string;
    summary: string;
    snippet?: string;
    messages?: Message[];
}

export const useChatHistory = () => {
    const {
        currentSessionId,
        currentMessages,
        loadSession,
        startNewSession,
        conversations,
        refreshConversations,
        addMessage,
        deleteSession,
        deleteAllSessions
    } = useAccount();

    return {
        currentSessionId,
        currentMessages,
        addMessage,
        loadSession,
        startNewSession,
        getSessionHistories: () => conversations || [],
        refreshConversations,
        deleteSession,
        deleteAllSessions,
        downloadHistory: async () => {
            if (!conversations) return;
            
            try {
                // Fetch full message history for all sessions in parallel
                const fullHistory = await Promise.all(
                    conversations.map(async (session) => {
                        const messages = await getChatHistory(session.sessionId);
                        return {
                            ...session,
                            messages
                        };
                    })
                );
                
                // Create and trigger download
                const blob = new Blob([JSON.stringify(fullHistory, null, 2)], { type: 'application/json' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `chat-history-${new Date().toISOString().split('T')[0]}.json`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            } catch (error) {
                console.error('Error exporting chat history:', error);
            }
        },
        importHistory: (file: File) => { console.log('Import history functionality removed from UI', file); }
    };
};
